module.exports = __webpack_public_path__ + "static/img/Keenan-Palasia.20894bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Keenan-Palasia.jpg
// module id = E4l9
// module chunks = 0